import { TourStep } from '../../models/tour.model';

export const TEXT_SEARCH_TOUR: TourStep[] = [
  {
    title: 'Text Search in Semeris Docs',
    element: '.search-input',
    intro: `
        <p><b>Text Search</b> is a powerful <b>search engine</b> in Semeris Docs with fast results from millions of paragraphs.</p>
        <p>Press <b>Enter</b> or click the <b>Search</b> button to begin searching.</p>
      `,
  },
  {
    title: 'Search from Anywhere',
    element: 'semeris-search-box',
    intro: `
        <p>Remember! You can also search for <b>phrases</b> or <b>paragraphs</b> from anywhere in the app using <b>Toolbar Search</b>.</p>
        <p><i>Let's dive into results.</i></p>
      `,
  },
  {
    title: 'Filtering Search Results',
    element: 'semeris-deal-filter-selector',
    intro: `
        <p>Select a <b>Deal Filter</b> to focus results on your deal universe.</p>
      `,
  },
  {
    title: 'Load More Results',
    element: '.search-input-addons.chip-list',
    intro: `
        <p>For performance, only top items are loaded. Click <b>Load More</b> to see more.</p>
      `,
  },
  {
    title: 'Search Results',
    element: 'semeris-similar-paragraph-list #semeris-scroll-item-0 .similar-paragraph-header',
    intro: `
        <p>Results indicate the <b>deal</b> and associated <b>library and asset class</b>.</p>
      `,
  },
  {
    title: 'Add to Selected Deals',
    element: 'semeris-similar-paragraph-list #semeris-scroll-item-0 semeris-add-remove-control',
    intro: `
        <p>Add interesting deals to <b>Selected Deals</b> with the <i class="material-icons">add</i> icon. This helps you get back to them later.</p>
      `,
  },
  {
    title: 'Source References and Match Scores',
    element: 'semeris-similar-paragraph-list #semeris-scroll-item-0 .paragraph-heading-container',
    intro: `
        <p>Above each resulting paragraph, you'll find references to the <b>document</b>, <b>page</b>, and <b>section</b> where the paragraph is located.</p>
        <p>Two colored bars reflect the match's quality based on a usual <b>search metric</b> and a <b>blackline-based metric</b>.</p>
      `,
  },
  {
    title: 'Advanced Search Settings',
    element: '.document-search-filters',
    intro: `
        <p>The Text Search offers a suite of features to configure <b>matching rules</b>, <b>highlighting</b>, <b>result formatting</b>, and <b>ordering</b>.</p>
        <p>Feel free to experiment with these settings to optimize your search experience.</p>
        <p><i>That's the end of this tour. Happy searching!</i></p>
      `,
  },
];
